import { faChevronDown, faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { colors } from "../../../../global";

const BasicInformation = ({
  sheetList,
  metadata,
  handleSheetChange,
  handleSheetNameChange,
  handleOverwriteSheet,
  openExcelModal,
  excelSelectableFields,
}) => {
  const fields = [
    "first_row",
    "ratecard",
    "service",
    "from_zone",
    "to_zone",
    "reciprocal",
    "cubic_conversion",
    "basic_buy",
    "basic_sell",
    "minimum_buy",
    "minimum_sell",
  ];
  // Fields that support Excel range selection
  const formatLabel = (key) => {
    return key.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold" style={{ color: colors.primary }}>
          Basic Information
        </h3>
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={faFileExcel}
            size={16}
            style={{ color: colors.darkGray }}
          />
          <span className="text-sm" style={{ color: colors.darkGray }}>
            Configuration
          </span>
        </div>
      </div>

      {/* Main Content Card */}
      <div className="bg-white rounded-xl border border-gray-200 p-6 space-y-6">
        {/* Sheet Selection */}
        {sheetList.length > 0 && (
          <div className="space-y-2">
            <label
              className="text-sm font-medium"
              style={{ color: colors.darkGray }}
            >
              Sheet Name
            </label>
            <div className="relative">
              <select
                className="w-full px-4 py-3 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200 appearance-none bg-white pr-10"
                style={{
                  "--tw-ring-color": colors.primary + "40",
                  borderColor: metadata.sheet_information.sheet_id
                    ? colors.primary + "40"
                    : undefined,
                }}
                value={metadata.sheet_information.sheet_name || ""}
                onChange={(e) => {
                  const selectedSheet = e.target.value;
                  if (selectedSheet) {
                    handleSheetNameChange(selectedSheet);
                  }
                }}
              >
                <option disabled value="" className="text-gray-400">
                  Select Sheet Name
                </option>
                {sheetList.map((sheet, index) => (
                  <option key={index} value={sheet} className="py-2">
                    {sheet}
                  </option>
                ))}
              </select>
              <FontAwesomeIcon
                icon={faChevronDown}
                size={16}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none"
                style={{ color: colors.darkGray }}
              />
            </div>
          </div>
        )}

        {/* Configuration Fields */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {fields.map((key) => {
            const isExcelSelectable = excelSelectableFields.includes(key);

            return (
              <div key={key} className="space-y-2">
                <label
                  className="text-sm font-medium"
                  style={{ color: colors.darkGray }}
                >
                  {formatLabel(key)}
                </label>

                {isExcelSelectable ? (
                  <div className="flex">
                    <input
                      type="text"
                      placeholder={`Enter ${formatLabel(key).toLowerCase()}`}
                      className="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-l-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200"
                      style={{
                        "--tw-ring-color": colors.primary + "40",
                        borderColor: metadata.sheet_information[key]
                          ? colors.primary + "40"
                          : undefined,
                      }}
                      value={metadata.sheet_information[key] ?? ""}
                      onChange={(e) => handleSheetChange(key, e.target.value)}
                    />
                    {openExcelModal &&
                      (metadata.file_name.endsWith(".csv") ||
                        metadata?.sheet_information?.sheet_name) && (
                        <button
                          onClick={() => openExcelModal(key)}
                          type="button"
                          aria-label={`Open Excel Sheet to select ${formatLabel(
                            key
                          )}`}
                          className="px-3 py-2 border border-l-0 border-gray-200 rounded-r-lg hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center"
                          style={{ color: colors.primary }}
                        >
                          <FontAwesomeIcon icon={faFileExcel} size={16} />
                        </button>
                      )}
                  </div>
                ) : (
                  <input
                    type="text"
                    placeholder={`Enter ${formatLabel(key).toLowerCase()}`}
                    className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:border-transparent transition-all duration-200"
                    style={{
                      "--tw-ring-color": colors.primary + "40",
                      borderColor: metadata.sheet_information[key]
                        ? colors.primary + "40"
                        : undefined,
                    }}
                    value={metadata.sheet_information[key] ?? ""}
                    onChange={(e) => handleSheetChange(key, e.target.value)}
                  />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BasicInformation;
